var _path, _rect, _path2, _path3, _path4, _path5, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrackResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.747 47.903v94.276a2 2 0 002 2h87.165a2 2 0 002-2V47.903a2 2 0 00-2-2H3.747a2 2 0 00-2 2z",
    fill: "#F4F0F1",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.208,
    y: 54.524,
    width: 72.244,
    height: 70.69,
    rx: 6,
    fill: "#89EC54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.743 78.339l-7.304 28.867a2 2 0 001.939 2.49h45.66c1.52 0 2.484-1.626 1.755-2.959l-8.94-16.352a2 2 0 00-3.314-.294l-6.898 8.576a2 2 0 01-3.142-.031L31.265 77.607c-1.02-1.32-3.113-.886-3.522.732zM64.721 80.672c4.818-1.908 4.096-8.586 0-9.54M64.721 80.911c11.323 0 8.673-11.21 0-10.017",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.852 9.998l4.544-8.922c.904 0 1.771.313 2.41.87.64.559.999 1.315.999 2.104v3.965h6.43c.329-.003.655.056.956.174.301.118.568.291.784.508.216.217.376.472.468.748.092.276.114.566.064.85l-1.568 8.923a1.932 1.932 0 01-.775 1.213 2.48 2.48 0 01-1.497.472H90.852m0-10.905h-3.408a2.45 2.45 0 00-1.607.58c-.426.373-.665.877-.665 1.403v6.94c0 .525.239 1.03.665 1.401.426.372 1.004.581 1.607.581h3.408m0-10.905V20.903",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.208 132.11h72.244",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.322 39.993a1 1 0 001.654 1.125l-1.654-1.125zm44.113-24.566a1 1 0 10.293-1.978l-.293 1.978zm-19.86 22.544l-.924-.381.924.38zm-22.599 3.147c4.265-6.27 7.806-7.692 10.447-7.356 2.756.35 5.092 2.655 6.8 5.102l1.64-1.146c-1.767-2.53-4.536-5.476-8.187-5.94-3.767-.48-7.935 1.719-12.354 8.215l1.654 1.125zM60.5 38.352c1.749-4.244 4.567-10.366 7.99-15.251 1.714-2.445 3.544-4.53 5.426-5.92 1.879-1.387 3.721-2.02 5.519-1.754l.293-1.978c-2.502-.372-4.87.551-7 2.123-2.126 1.57-4.101 3.85-5.875 6.38-3.55 5.068-6.436 11.351-8.202 15.638l1.85.762zm-6.276.512c.775 1.11 2.107 1.55 3.28 1.478 1.175-.071 2.456-.68 2.996-1.99l-1.85-.762c-.166.405-.62.716-1.268.756-.651.04-1.232-.217-1.519-.628l-1.64 1.146z",
    fill: "#0C0A0C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.922,
    cy: 35.127,
    rx: 13.331,
    ry: 5.603,
    fill: "#0C0A0C"
  })));
}

export default SvgTrackResults;